import gql from "graphql-tag";

export const FETCH_ACCOUNT_PLANS = gql`
  query FetchAccountPlans {
    data: fetchAccountPlans {
      alert {
        type
        message
      }
      payload
    }
  }
`;

export const CHANGE_DISTRIBUTOR_ACCOUNT_PLAN = gql`
  mutation ChangeDistributorAccountPlan($accountPlanId: String!) {
    data: changeDistributorAccountPlan(accountPlanId: $accountPlanId) {
      alert {
        type
        message
      }
      payload
    }
  }
`;

export const FETCH_ACCOUNT_PLAN_ACTIONS = gql`
  query FetchAccountPlanActions($accountPlanId: String!) {
    data: fetchAccountPlanActions(accountPlanId: $accountPlanId) {
      alert {
        type
        message
      }
      payload
    }
  }
`;

export const FETCH_BILLS = gql`
  query FetchBills {
    data: fetchBills {
      alert {
        type
        message
      }
      payload
    }
  }
`;
